module.exports = __webpack_public_path__ + "static/media/RAEA-WEB-Logo.1d485e21.png";